import { render, staticRenderFns } from "./ProductComponentInputs.vue?vue&type=template&id=53475cd2&"
import script from "./ProductComponentInputs.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports